/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeletePlaceholderAllocationInput = {|
  id?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type deletePlaceholderAllocationMutationVariables = {|
  input: DeletePlaceholderAllocationInput
|};
export type deletePlaceholderAllocationMutationResponse = {|
  +deletePlaceholderAllocation: ?{|
    +deletedAllocationId: ?string
  |}
|};
export type deletePlaceholderAllocationMutation = {|
  variables: deletePlaceholderAllocationMutationVariables,
  response: deletePlaceholderAllocationMutationResponse,
|};
*/


/*
mutation deletePlaceholderAllocationMutation(
  $input: DeletePlaceholderAllocationInput!
) {
  deletePlaceholderAllocation(input: $input) {
    deletedAllocationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeletePlaceholderAllocationInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletePlaceholderAllocationPayload",
    "kind": "LinkedField",
    "name": "deletePlaceholderAllocation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedAllocationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deletePlaceholderAllocationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deletePlaceholderAllocationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "deletePlaceholderAllocationMutation",
    "operationKind": "mutation",
    "text": "mutation deletePlaceholderAllocationMutation(\n  $input: DeletePlaceholderAllocationInput!\n) {\n  deletePlaceholderAllocation(input: $input) {\n    deletedAllocationId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f405f4978fc7be01e5e0ccca2eb35099';

module.exports = node;
